module.exports = __webpack_public_path__ + "img/img_product_01_2@2x.6448c724.png";